import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function BlinkViewer({ statuses, onClose }) {
    const [currentIndex, setCurrentIndex] = useState(0);

    // Auto-advance
    useEffect(() => {
        const timer = setTimeout(() => {
            if (currentIndex < statuses.length - 1) {
                setCurrentIndex(prev => prev + 1);
            } else {
                onClose();
            }
        }, 5000); // 5 seconds

        return () => clearTimeout(timer);
    }, [currentIndex, statuses.length, onClose]);

    const currentStatus = statuses[currentIndex];

    if (!currentStatus) return null;

    return (
        <div className="fixed inset-0 z-[100] bg-black flex items-center justify-center">
            {/* Progress Bar Container - Safe Area Top */}
            <div className="absolute top-0 left-0 right-0 pt-[env(safe-area-inset-top,20px)] px-2 flex gap-1 z-20 bg-gradient-to-b from-black/50 to-transparent pb-4">
                {statuses.map((_, idx) => (
                    <div key={idx} className="h-1 flex-1 bg-white/30 rounded-full overflow-hidden">
                        <motion.div
                            initial={{ width: "0%" }}
                            animate={{ width: idx < currentIndex ? "100%" : idx === currentIndex ? "100%" : "0%" }}
                            transition={{ duration: idx === currentIndex ? 5 : 0, ease: "linear" }}
                            className="h-full bg-white"
                        />
                    </div>
                ))}
            </div>

            {/* Close Button - Larger Hit Area */}
            <button
                onClick={onClose}
                className="absolute top-[env(safe-area-inset-top,20px)] right-2 z-30 text-white p-4 hover:bg-white/10 rounded-full transition-colors"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            </button>

            {/* Main Content */}
            <div className="w-full h-full flex flex-col items-center justify-center relative">
                <img
                    src={currentStatus.imageUrl}
                    alt="Status"
                    className="max-h-full max-w-full object-contain"
                />

                {/* Caption */}
                {currentStatus.caption && (
                    <div className="absolute bottom-10 bg-black/50 px-4 py-2 rounded-lg backdrop-blur-md">
                        <p className="text-white text-lg font-medium">{currentStatus.caption}</p>
                    </div>
                )}
            </div>

            {/* Touch Navigation Overlay */}
            <div className="absolute inset-0 flex z-10">
                <div
                    className="w-1/3 h-full"
                    onClick={() => currentIndex > 0 ? setCurrentIndex(prev => prev - 1) : null}
                />
                <div
                    className="w-2/3 h-full"
                    onClick={() => currentIndex < statuses.length - 1 ? setCurrentIndex(prev => prev + 1) : onClose()}
                />
            </div>
        </div>
    );
}
